import { Card, CardContent, Typography, Box } from "@mui/material";
import { IComment } from "../../types/interfaces/IComment";
import { formatDateNumericDateAndHour } from "../../../global/utilities/DateFormatter";
import ParseHTML from "../../../global/utilities/ParseHTML";
import { CphConstants } from "../../constants/CphConstants";
import { useCphContext } from "../../hooks/useCphContext";

interface CommentCardProps {
    comment: IComment
    };

const CommentCard: React.FC<CommentCardProps> = ({ comment }) => {
    const { isStaff } = useCphContext();
    const isStaffCommenter = Number(comment.commenter?.isStaff) === 1;
    const showCommenterName = isStaff || !isStaffCommenter;
    const commenterName = `${comment.commenter?.firstName ?? ""} ${comment.commenter?.lastName ?? ""}`.trim();

   

    return (
        <Card
            elevation={0}
            sx={{ width: '100%', height: '100%', maxWidth: '100%', mx: 0, px: 0, py: 0, boxShadow: 'none !important', border: 0 }}
        >
            <CardContent>
                <Typography
                    variant="h6"
                    gutterBottom
                >
                    {comment.staffOnlyFlag === 1 ? (
                        <>
                            <Typography component="span" sx={{ color: "#720522", fontWeight: 700 }}>
                                [Staff Only]
                            </Typography>{" "}
                            <strong>Comment:</strong>
                        </>
                    ) : (
                        <strong>Comment:</strong>
                    )}
                </Typography>

                <Typography variant="body2">
                    {ParseHTML(comment.text as string)}
                </Typography>
                <Box display="flex" flexDirection="column" alignItems="flex-end" mt={1}>
                    <Box display="flex" flexDirection="row" alignItems="flex-start" width="100%">
                        <Typography variant="body2" sx={{ minWidth: 90, fontWeight: 'bold', textAlign: 'left' }}>
                            <strong>Submitted By:</strong>{" "}
                            {showCommenterName
                                ? commenterName
                                : <strong>{CphConstants.StaffSignature}</strong>}
                        </Typography>
                     </Box>
                    <Box display="flex" flexDirection="row" alignItems="flex-start" width="100%">
                        <Typography variant="body2" sx={{ minWidth: 90, fontWeight: 'bold', textAlign: 'left' }}>
                            <strong>Date:</strong> {formatDateNumericDateAndHour(comment.commentDate)}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default CommentCard;
